import { mapGetters } from 'vuex'
import { baseChartMixin } from '@/reusable/base-chart/base-chart-mixin'
import * as apiTo from './api'

export function commonPropertiesMixin(api, customChartData) {
  return {
    mixins: [baseChartMixin],

    computed: {
      ...mapGetters('subscription-show', ['subscription'])
    },

    watch: {
      subscription: {
        handler(val) {
          val && this.getChartData()
        },
        immediate: true
      }
    },

    created() {
      this.customChartData = customChartData
    },

    methods: {
      getChartData() {
        apiTo.getChartData(api, this.subscription.id).then(({ data }) => {
          this.chartData = data.result.chart
          this.supportData = data.result.support_data
        })
      }
    }
  }
}
